export const validationStatus = {
  pending: 1,
  userActionRequired: 5,
  success: 10,
  error: 20
}
